import * as tslib_1 from "tslib";
import { BaseComponent } from "./BaseComponent";
var IsolatedScope = /** @class */ (function (_super) {
    tslib_1.__extends(IsolatedScope, _super);
    function IsolatedScope() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.readyCallbacks = $.Callbacks();
        return _this;
    }
    IsolatedScope.prototype.ready = function (callback) {
        if (this.readyCallbacks.fired()) {
            callback();
            return;
        }
        this.readyCallbacks.add(callback);
    };
    IsolatedScope.prototype.render = function (childNodes) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, isolatedStyles, options, frame, _b;
            var _this = this;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this.options, isolatedStyles = _a.isolatedStyles, options = tslib_1.__rest(_a, ["isolatedStyles"]);
                        frame = $('<iframe>', $.extend(options, {
                            'isolated-scope': ''
                        }));
                        frame.on('load', function () { return _this.mountIsolatedContent(); });
                        _b = this;
                        return [4 /*yield*/, Promise.all(Array.prototype.concat.apply([], childNodes))];
                    case 1:
                        _b.childNodes = _c.sent();
                        this.setChildComponentsAncestor();
                        return [2 /*return*/, frame];
                }
            });
        });
    };
    IsolatedScope.prototype.getChildComponents = function () {
        return this.getHostElement()
            .contents()
            .find('[data-xmid]')
            .toArray()
            .map(function (elem) { return $(elem).data('component'); })
            .filter(function (component) { return component != null; });
    };
    IsolatedScope.prototype.mountIsolatedContent = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var html;
            return tslib_1.__generator(this, function (_a) {
                html = $('<html>', {
                    html: (this.options.isolatedStyles ? ["<head><base target=\"_parent\"><style>" + this.options.isolatedStyles + "</style></head>"] : []).concat([
                        $('<body>', {
                            html: this.childNodes
                        })
                    ])
                });
                this.getHostElement()
                    .contents()
                    .find('html')
                    .replaceWith(html);
                this.readyCallbacks.fire();
                return [2 /*return*/];
            });
        });
    };
    IsolatedScope.prototype.setChildComponentsAncestor = function () {
        for (var i = 0; i < this.childNodes.length; i++) {
            this.childNodes[i].data('component').parentComponent = this;
        }
    };
    return IsolatedScope;
}(BaseComponent));
export { IsolatedScope };
//# sourceMappingURL=IsolatedScope.js.map


//////////////////
// WEBPACK FOOTER
// ../~/xm-ui/components/IsolatedScope.js
// module id = 36
// module chunks = 1